import React from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import './SlidingDrawer.scss';
import Toast from 'components/Toast';

const INITIAL_FORM_STATE = {
  id: null,
  name: '',
  type: '',
  pairedDevice: null,
};

export default function SlidingDrawer({ isOpen, onClose, title, children, handleSave, formData, prevData, showFooter = true, component="" }) {
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  }); 
  const [isDirty, setIsDirty] = React.useState(false);

  React.useEffect(() => {

    const checkFormData =  Object.values(formData || {}).every(
      (value) => value === null || value === undefined || value === ''
    );

    if(checkFormData) {
      setIsDirty(false);
      return
    } 

    if (!prevData) {
      // Dynamically create an initial state with the same keys as formData
      const dynamicInitialState = {};
      Object.keys(formData || {}).forEach(key => {
        // Set empty string for string fields, null for others (customize as needed)
        dynamicInitialState[key] = typeof formData[key] === 'string' ? '' : null;
      });
      setIsDirty(JSON.stringify(formData) !== JSON.stringify(dynamicInitialState));
      return;
    }
    const formCopy = { ...formData };
    const prevCopy = { ...prevData };
    if (!formCopy.id) delete prevCopy.id;
    
    const isChanged = JSON.stringify(formCopy) !== JSON.stringify(prevCopy);

    setIsDirty(isChanged);
  }, [formData, prevData, isOpen]);


  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onEscClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, formData, prevData]);

  const onEscClose = () => {
    const formCopy = { ...formData };
    const prevCopy = { ...prevData };

    function isEmptyValue(value) {
      if (value === null || value === undefined || value === '') return true;
      if (typeof value === 'object') {
        return Object.values(value).every(isEmptyValue);
      }
      return false;
    }

    const checkFormData = isEmptyValue(formData);

    // const checkFormData =  Object.values(formData || {}).every(
    //   (value) => value === null || value === undefined || value === ''
    // );
    
    if(checkFormData) {
      onClose()
      return
    }
    if (!formCopy.id) {
      delete prevCopy.id;
    }
    if(formData?.id || prevData?.id || component === "gateway"){
      if(JSON.stringify(formCopy) !== JSON.stringify(prevCopy)){
        setToastConfig((prev) => ({...prev, isVisible: true, message: "Please click one of the buttons to exit."}))
      }else{
        onClose()
      }
    } else {
      if (!checkFormData) {
        const hasAttributes = Object.keys(formData || {})?.some(k => k.toLowerCase() === "attributes");
        if (hasAttributes) {
          const attributes = formData?.Attributes || [];
          const prevAttributes = prevData?.Attributes || [];
          if (JSON.stringify(attributes) !== JSON.stringify(prevAttributes) || formData?.name !== prevData?.name) {
            setToastConfig((prev) => ({ ...prev, isVisible: true, message: "Please click one of the buttons to exit." }));
            return;
          } else {
            onClose();
          }
        } else {
          // Only show toast if form data has actually changed
          if (isDirty) {
            setToastConfig((prev) => ({ ...prev, isVisible: true, message: "Please click one of the buttons to exit." }));
            return;
          } else {
            onClose();
          }
        }
      } else {
        onClose();
      }
    }
    // }else{
    //   if(!checkFormData){
    //     const hasAttributes = Object.keys(formData || {})?.some(k => k.toLowerCase() === "attributes");
    //     if(hasAttributes){
    //       const attributes = formData?.Attributes || [];
    //       const prevAttributes = prevData?.Attributes || [];
    //       if (JSON.stringify(attributes) !== JSON.stringify(prevAttributes) || formData?.name !== prevData?.name) {
    //         setToastConfig((prev) => ({...prev, isVisible: true, message: "Please click one of the buttons to exit."}))
    //         return
    //       }else{
    //         onClose()
    //       }
    //     }else{
    //       setToastConfig((prev) => ({...prev, isVisible: true, message: "Please click one of the buttons to exit."}))
    //       return
    //     }
    //   }else{
    //     onClose()
    //   }
    // }
  }

  return (
    <>
    <SlidingPane
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      from="right"
      width="50vw"
      // onRequestClose={onClose}
      onRequestClose={() => onEscClose()}
      title={
          <div className="sliding-header">
              <h5 className='drawer-title'>{title}</h5>
              <span className='cross-btn' onClick={onEscClose}>
                <i className='dx-icon-close'></i>
              </span>
          </div>
      }
      overlayClassName="custom-overlay"
      className="custom-drawer"
    >
      <div className="sliding-content">
        {isOpen && children}
      </div>
      
      {showFooter && isDirty && isOpen && (
        <div className="sliding-footer">
          <div className='btn-wrapper'>
            <button className='save-btn' type='button' onClick={handleSave}>Save</button>
            <button className='cancel-btn' onClick={onClose}>Discard</button>
          </div>
        </div>
      )}
    </SlidingPane>

    <Toast
      setParentToastConfig={setToastConfig}
      toastBody={toastConfig}
      key={'toast'}
    />
    </>
  );
}